import React, { useState } from "react";
import { getProductDisplayName } from "../../utils/productDisplayName";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import styles from "./ReturnsSectionMobile.module.css";

const STATUS_MAP = {
  Повернено: "Повернено повністю",
  "Частково повернено": "Часткове повернення",
};

function getReturnAmount(returnedItems) {
  return returnedItems.reduce(
    (sum, item) =>
      sum + (item.totalReturnAmount || item.price * item.returnQuantity),
    0
  );
}

const ReturnsSectionMobile = ({ returns }) => {
  const [openDetails, setOpenDetails] = useState(null);

  const toggleDetails = (orderId) => {
    setOpenDetails(openDetails === orderId ? null : orderId);
  };

  if (!returns?.length)
    return <div className={styles.emptyMsg}>У вас ще немає повернень.</div>;

  return (
    <div className={styles.returnsListMobile}>
      {returns.map((ret) => (
        <div className={styles.returnCardMobile} key={ret._id}>
          <div className={styles.returnCardHeader}>
            <div>
              <span className={styles.returnNum}>№{ret.orderNumber}</span>
              <span className={styles.returnDate}>
                {/* Відступ + дата та час повернення */}
                {ret.returnedItems[0]?.returnDate ? (
                  <>
                    <span className={styles.returnDateSpacer}></span>
                    {new Date(ret.returnedItems[0].returnDate).toLocaleString(
                      "uk-UA"
                    )}
                  </>
                ) : (
                  "-"
                )}
              </span>
            </div>
            <div className={styles.status}>
              {STATUS_MAP[ret.status] || ret.status}
            </div>
          </div>
          <div className={styles.returnSum}>
            <span>Сума повернення: {getReturnAmount(ret.returnedItems)} ₴</span>
            <span>
              {ret.returnedItems.length} товар
              {ret.returnedItems.length === 1 ? "" : "и"}
            </span>
          </div>
          <button
            className={styles.orderExpandBtn}
            onClick={() => toggleDetails(ret._id)}
          >
            {openDetails === ret._id ? (
              <>
                Згорнути <IoChevronUp />
              </>
            ) : (
              <>
                Детальніше <IoChevronDown />
              </>
            )}
          </button>

          {openDetails === ret._id && (
            <div className={styles.returnDetailsMobile}>
              <h4 className={styles.productsTitle}>Повернені товари</h4>
              {ret.returnedItems.map((item, idx) => (
                <div className={styles.returnItem} key={item.productId || idx}>
                  <div>
                    <div className={styles.prodTitle}>
                      Артикул: {item.productCode} | {getProductDisplayName(item)}
                    </div>
                  </div>
                  <div className={styles.prodInfoRow}>
                    <span>
                      повернено: {item.returnQuantity} × {item.price} грн
                    </span>
                    <span className={styles.returnAmount}>
                      сума повернення: -
                      {item.totalReturnAmount ||
                        item.returnQuantity * item.price}{" "}
                      грн
                    </span>
                  </div>
                  <div className={styles.prodInfoRow}>
                    {/* 5. Дата та час повернення */}
                    Дата та час повернення:{" "}
                    {item.returnDate
                      ? new Date(item.returnDate).toLocaleString("uk-UA")
                      : "-"}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReturnsSectionMobile;
